import React from "react";
import Hero from "../components/Hero/Hero";
import Releases from "../components/Projects/Release/Releases";
import Projects from "../components/Projects/Projects/Projects";
import Specialization from "../components/Projects/Specialization/Specialization";
import About from "../components/About/About";
import Contact from "../components/Contact/Contact";
import Footer from "../components/Footer/Footer";
import FixSocialIcon from "../components/SocialIcon/FixSocialIcon";
import ScrollToTop from "../components/SocialIcon/ScrollToTop";
function Home() {
  return (
    <>
      <Hero />
      <Releases />
      <Projects />
      <Specialization />
      <About />
      <Contact />
      <FixSocialIcon />
      <Footer />
      <ScrollToTop />
    </>
  );
}

export default Home;
